module.exports = __webpack_public_path__ + "static/media/moon-cloud.f8b1d505.svg";